const literales_es = {
    Perfil: "Perfil",
    Usuarios: "Usuarios",
    CerrarSesion: "Cerrar sesión",
  };
  
  export default literales_es;
  